/**
 * A small rendition of a picture kept on Flobi's storage, for a tile: the whole original
 * is megabytes the panel has no use for. Anything kept elsewhere is shown as it is.
 * `size` is the longest side in device pixels (320 for a tile; more for a preview).
 */
export function tileUrl(src: string, size = 320, quality = 70): string {
  try {
    const url = new URL(src);
    // An SVG is already small and sharp at any size; the image CDN does not resize one.
    if (url.hostname !== 'storage.flobi.ai' || url.pathname.startsWith('/cdn-cgi/') || url.search || /\.svgz?$/i.test(url.pathname)) return src;
    return `${url.origin}/cdn-cgi/image/width=${size},height=${size},fit=scale-down,format=auto,quality=${quality}${url.pathname}`;
  } catch {
    return src;
  }
}
